import { render, staticRenderFns } from "./CAUSAL_AUTO.vue?vue&type=template&id=131919a2&"
import script from "./CAUSAL_AUTO.vue?vue&type=script&lang=js&"
export * from "./CAUSAL_AUTO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports